import PageModel, { PageFilters } from "../models/page.model";
import { PageType } from "../types/page";
import { useReducerAsState } from "./useReducerAsState"

interface State {
    loading: boolean;
    error: string;
    page: PageType | null;
    pages: Array<PageType>;
    totalPages: number;
}

const usePages = () => {
    const [state, setState] = useReducerAsState<State>({
        loading: false,
        error: "",
        page: null,
        pages: [],
        totalPages: 0,
    }); 

    const { loading, error, page, pages, totalPages } = state

    const fetchPages = async (filters: PageFilters) => {
        setState({ loading: true, error: "", totalPages: 0 })
        const response = await PageModel.all(filters)
        if(response.error){
            setState({ loading: false, error: response.error, totalPages: 0 })
            return
        }

        setState({ loading: false, error: "", pages: response.pages?.data, totalPages: response.total })
    }

    const fetchPage = async (itemId: number): Promise<PageType | undefined> => {
        setState({ loading: true, error: "" })
        const response = await PageModel.find(itemId)
        if(response.error){
            setState({ loading: false, error: response.error })
            return undefined
        }

        setState({ loading: false, error: "", page: response.pages?.data[0] })
        return response.pages?.data[0]
    }

    const savePage = async (item: PageType): Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await PageModel.save(item)
        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

        setState({ loading: false, error: "" })
        return true
    }

    const deletePage = async (itemId: number): Promise<boolean> => {
        setState({ loading: true, error: "" })
        const response = await PageModel.remove(itemId)
        if(response.error){
            setState({ loading: false, error: response.error })
            return false
        }

        setState({ loading: false, error: "" })
        return true
    }

    return {
        loading, 
        error,
        page,
        pages,
        fetchPages,
        fetchPage,
        savePage,
        deletePage,
        totalPages
    }
}

export default usePages